var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundStack01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 346.3 343.9",
    style: {
      enableBackground: "new 0 0 346.3 343.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#71BD94;}\r\n\t.st1{fill:#010101;}\r\n\t.st2{fill:#899389;}\r\n\t.st3{fill:#C2E7F2;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{opacity:0.59;fill:#71BD94;}\r\n\t.st6{clip-path:url(#SVGID_00000124126711893213297110000009677334738433893027_);}\r\n\t.st7{fill:#647073;}\r\n\t.st8{fill:#D5B270;}\r\n\t.st9{fill:#C0C7CA;}\r\n\t.st10{fill:#BEC5C8;}\r\n\t.st11{fill:#EEC270;}\r\n\t.st12{fill:#EBC070;}\r\n\t.st13{fill:#CED5D8;}\r\n\t.st14{fill:#BFC5C9;}\r\n\t.st15{fill:#CBD2D5;}\r\n\t.st16{fill:#E0E6E8;}\r\n\t.st17{fill:#D2D8DB;}\r\n\t.st18{fill:#CBC1AA;}\r\n\t.st19{fill:#657374;}\r\n\t.st20{fill:#12B693;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M295.8,319.5h-169c-14.8,0-26.8-12-26.8-26.8v-169C100,109,112,97,126.8,97h169c14.8,0,26.8,12,26.8,26.8v169 C322.6,307.5,310.6,319.5,295.8,319.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.2,324.2H131.4c-19.9,0-36-16.2-36-36V128.3c0-19.9,16.2-36,36-36h159.8c19.9,0,36,16.2,36,36v159.8 C327.3,308,311.1,324.2,291.2,324.2z M131.4,101.7c-14.7,0-26.7,12-26.7,26.7v159.8c0,14.7,12,26.7,26.7,26.7h159.8 c14.7,0,26.7-12,26.7-26.7V128.3c0-14.7-12-26.7-26.7-26.7H131.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M207.6,19.8H63.1c-23.9,0-43.4,19.5-43.4,43.4v144.6c0,23.9,19.5,43.4,43.4,43.4h144.6 c23.9,0,43.4-19.5,43.4-43.4V63.2C251,39.2,231.5,19.8,207.6,19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M207.6,241.4H63.1c-18.6,0-33.7-15.1-33.7-33.7v-26.2l57.1-57.1c11.1-11,29-11,40.1,0l105.9,105.9 C226.3,237.1,217.5,241.4,207.6,241.4L207.6,241.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M241.4,207.7c0,5.2-1.3,10.1-3.4,14.6L133.3,117.6c-14.8-14.8-38.9-14.8-53.7,0l-50.2,50.2V63.2 c0-18.6,15.1-33.7,33.7-33.7h144.6c18.6,0,33.7,15.1,33.7,33.7V207.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 178.7,
    cy: 82.4,
    r: 24.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 178.7,
    cy: 82.4,
    r: 14.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundStack01);
export default __webpack_public_path__ + "static/media/background_stack-01.f3ab84568f1fec1d336ea5de99e1effc.svg";
export { ForwardRef as ReactComponent };